// extracted by mini-css-extract-plugin
export default {"main":"TermsAndCondition_main__Mc97v","mainSection":"TermsAndCondition_mainSection__7dkVv"};